import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskInput from "TaskDialogCommon/TaskInput";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import CityChecklist from "TaskDialogCommon/CityChecklist";
import Instruction from "TaskDialogCommon/Instruction";
import Warning from "TaskDialogCommon/Warning";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "mining";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        selectedcities: {
          "1": false,
          "2": false,
          "3": false,
          "4": false,
          "99": false,
        },
        noOfHits: "99999",
        troops: {
          u141: "500",
        },
        unboxtroops: true,
        getfarthestmine: false,
        doExCavs: true,
        doComCavs: true,
        minShards: "0",
        maxRounds: "9999",
        portcitiestocorners: false,
        forcerecallminesonstopping: false,
        poprunemins: 0,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        taskConfig.troops = { ...storeddata.troops };
        taskConfig.noOfHits = storeddata.noOfHits;
        taskConfig.selectedcities = { ...storeddata.selectedcities };
        if (storeddata.getfarthestmine !== undefined) {
          taskConfig.getfarthestmine = storeddata.getfarthestmine;
        }
        if (storeddata.unboxtroops !== undefined) {
          taskConfig.unboxtroops = storeddata.unboxtroops;
        }
        if (storeddata.doExCavs !== undefined) {
          taskConfig.doExCavs = storeddata.doExCavs;
        }
        if (storeddata.doComCavs !== undefined) {
          taskConfig.doComCavs = storeddata.doComCavs;
        }
        if (storeddata.minShards !== undefined) {
          taskConfig.minShards = storeddata.minShards;
        }
        if (storeddata.maxRounds !== undefined) {
          taskConfig.maxRounds = storeddata.maxRounds;
        }
        if (storeddata.forcerecallminesonstopping !== undefined) {
          taskConfig.forcerecallminesonstopping =
            storeddata.forcerecallminesonstopping;
        }
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;

    return (
      <TaskDialog heading={"Mining Run"}>
        <CityChecklist
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          label={"Select Cities to mine from"}
          param={"selectedcities"}
        />
        <TaskInput
          label={"Max No of marches"}
          value={taskConfig.noOfHits}
          onChange={(event) => setValue(event, "noOfHits")}
          instruction={`*A "March" is one hero to send. Sending 50 heroes to mine is sending
          50 marches.`}
        />
        <TaskInput
          label={"Dont attack mines having less than this no of Shards:"}
          value={taskConfig.minShards}
          onChange={(event) => setValue(event, "minShards")}
        />
        <TaskInput
          label={"Max Rounds:"}
          value={taskConfig.maxRounds}
          onChange={(event) => setValue(event, "maxRounds")}
          instruction={`*A "Round" is one batch of heroes to send. 1 round means trying to
          send all 50 heroes ONCE and then stopping. Keep this value very
          high. Only set it to 1 when you want to send all heroes only once to
          the farthest mines just before a gemshard :)`}
        />

        <TaskCheckBox
          label={"Include Extraordinary Caverns."}
          param={"doExCavs"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TaskCheckBox
          label={"Include Common Caverns."}
          param={"doComCavs"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TaskCheckBox
          label={
            "Try to port my cities to map corners using Radagast port item."
          }
          param={"portcitiestocorners"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TaskCheckBox
          label={
            "When task is stopped, force recall all miners to their cities."
          }
          param={"forcerecallminesonstopping"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TaskCheckBox
          label={"Send troops to the farthest mines instead of nearest."}
          param={"getfarthestmine"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <Instruction>
          ^*This will pick the farthest mines first so that you can send heroes
          with T1 in preparation, just before a gemshard :)
        </Instruction>

        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TroopMapSelector
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          label={"Add Troops To Send"}
          param={"troops"}
        />

        <Warning>
          *Troops selected will be sent with EVERY hero. So if 500 Lyceans are
          selected, each march will be sent with 500 Lyceans. <br />
          *Troops NOT present in city will be unboxed if available boxed. Please
          choose troops carefully.
        </Warning>

        <TaskInput
          label={
            "Auto Pop 200% Attack Runes for mins before every hit(Optional)"
          }
          value={taskConfig.poprunemins}
          onChange={(event) => setValue(event, "poprunemins")}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run Miner"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
